import PropTypes from 'prop-types'
import { createElement, isValidElement } from 'react'
import { Accordion as BootstrapAccordion } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

import { actions } from '@/reducers/accordion'

const LIMIT = 600

export const Show = ({ children, eventKey }) => {
  const dispatch = useDispatch()

  const handleonEntered = collapsibleElement => {
    const isShowingReadMore = collapsibleElement.clientHeight > LIMIT

    dispatch(actions.updateIsShowingReadMore(isShowingReadMore))
  }

  return (
    <BootstrapAccordion.Collapse
      eventKey={eventKey}
      id={eventKey}
      onEntered={handleonEntered}
    >

      <Choose>
        <When condition={isValidElement(children)}>
          {children}
        </When>
        <Otherwise>
          {
            createElement(
              'div',
              '',
              children
            )
          }
        </Otherwise>
      </Choose>
    </BootstrapAccordion.Collapse>
  )
}

Show.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  eventKey: PropTypes.string.isRequired
}
